export const SHOW = 'ACTIVE_MODAL_SHOW';
export const HIDE = 'ACTIVE_MODAL_HIDE';



// WEBPACK FOOTER //
// ./src/constants/activeModal.js